<template>
  <div id="app">
      <router-view/>
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view> -->
  </div>
</template>

<script>
import positionBanner  from './components/positionBanner/positionBanner'
import {Push} from '@/utils/push'
export default {
  name: 'App',
  components:{positionBanner},
  data(){
    return{
    }
  },
  mounted(){
    console.log("url参数---------->",this.getQueryString("role"));
     localStorage.setItem('role',this.getQueryString("role"))
    // var connection = new Push({
    //   // url: 'wss://v.pole.anhuixindun.com/ws', // websocket地址正式(一期)
    //   // app_key: '4dd36dcd4be929378cdb5212126cfdfc',//一期
    //   url: 'wss://v2.pole.anhuixindun.com/ws', // websocket地址正式(二期)
    //   app_key: 'ebf4f80c3a4de85f2cb1c23a3fd7bf1b',//二期
    //   auth: '/plugin/webman/push/auth' // 订阅鉴权(仅限于私有频道)一期/二期

    //   // url: 'wss://gt2.testx.dev.ahtianqiao.com/ws', // websocket地址测试(二期)
    //   // url: 'wss://v.pole.anhuixindunzhecom/ws_test', // websocket地址正式(二期)
    //   // app_key: 'ebf4f80c3a4de85f2cb1c23a3fd7bf1b',//二期  
    //   // auth: '/plugin/webman/push/auth' // 订阅鉴权(仅限于私有频道)二期未改动
    // });
    // this.aa(connection)
  },
  methods:{
    getQueryString(name){
          var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
          var r = window.location.search.substr(1).match(reg);
          if(r!=null)return  unescape(r[2]); return null;
      },
    aa(connection){
      console.log('11---->app.vue',connection);
      this.$eventBus.$emit('connectWeb',connection)
    }
  }
}
</script>

<style>
  @font-face{
    font-family:myFont;
    src:url('../static/font/Digital-7Mono.ttf');
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue